import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Training Attendance (Trainee) ")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Association", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "row mt-3" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Course", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Batches", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "col-md-4 mt-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_26 = {
  key: 0,
  class: "pt-6 pb-2"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-header border-0 cursor-pointer bg-success",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#register_trainee",
    "aria-expanded": "true",
    "aria-controls": "form"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Course Details ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-body row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm badge bg-primary" }, [
        /*#__PURE__*/_createTextVNode(" Total Training Month "),
        /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary p-3" }, "3")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm badge bg-primary" }, [
        /*#__PURE__*/_createTextVNode(" Total Training Month "),
        /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary p-3" }, "3")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm badge bg-primary" }, [
        /*#__PURE__*/_createTextVNode(" Total Training Month "),
        /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary p-3" }, "3")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm badge bg-primary" }, [
        /*#__PURE__*/_createTextVNode(" Total Training Month "),
        /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary p-3" }, "3")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm badge bg-primary" }, [
        /*#__PURE__*/_createTextVNode(" Total Training Month "),
        /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary p-3" }, "3")
      ])
    ])
  ])
], -1)
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-3" }, "Term Details", -1)
const _hoisted_30 = { class: "card mb-5 mb-xl-10" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-dark fs-7 p-2 rounded-0",
        title: "Download Xlse",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-excel fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" Excel ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-warning fs-7 p-2 rounded-0",
        title: "Download PDF",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-pdf fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" PDF ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-primary fs-7 p-2 rounded-0",
        title: "Download CSV",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-csv fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" CSV ")
      ])
    ])
  ])
], -1)
const _hoisted_32 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_33 = { class: "collapse show" }
const _hoisted_34 = { class: "card-body border-top p-6" }
const _hoisted_35 = {
  class: "current",
  "data-kt-stepper-element": "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Tranche-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-3",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-4",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Association",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.entity_short_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("[" + _toDisplayString(info.entity_short_name) + "]-" + _toDisplayString(info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Institute",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.entity_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _hoisted_20,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Course",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Tranche-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-3",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-4",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _hoisted_23,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Courses",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.entity_short_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.entity_short_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.courseNotice())),
                      type: "button",
                      class: "btn btn-success mt-4",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_25
                    ])
                  ])
                ])
              ]),
              (_ctx.showCourseNotice == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    (_ctx.showCourseNotice == true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, [
                                    _createVNode(_component_Datatable, {
                                      "table-data": _ctx.tableData,
                                      "table-header": _ctx.tableHeader,
                                      "enable-items-per-page-dropdown": true
                                    }, {
                                      "cell-day": _withCtx(({ row }) => [
                                        _createTextVNode(_toDisplayString(row.day), 1)
                                      ]),
                                      "cell-training_date": _withCtx(({ row: lists }) => [
                                        _createTextVNode(_toDisplayString(lists.training_date), 1)
                                      ]),
                                      "cell-training_day": _withCtx(({ row: lists }) => [
                                        _createTextVNode(_toDisplayString(lists.training_day), 1)
                                      ]),
                                      "cell-start_time": _withCtx(({ row: lists }) => [
                                        _createTextVNode(_toDisplayString(lists.start_time), 1)
                                      ]),
                                      "cell-end_time": _withCtx(({ row: lists }) => [
                                        _createTextVNode(_toDisplayString(lists.end_time), 1)
                                      ]),
                                      "cell-daily_hour": _withCtx(({ row: lists }) => [
                                        _createTextVNode(_toDisplayString(lists.daily_hour), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["table-data", "table-header"])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}